import * as React from 'react'
import { responsiveAttrs, SrcSizes, SrcType, BaseType } from '../../utils/imageUtils'

type ResponsiveImage = {
    src?: string,
    alt: string,
    baseValue?: number,
    baseType?: BaseType,
    srcSizes?: SrcSizes,
    format?: SrcType,
    [attr: string]: any,
    skipStripTags?: boolean
}
export const ResponsiveImage = (props: ResponsiveImage) => {
    const { src, baseValue, format, baseType, srcSizes, skipStripTags, ...rest } = props

    if (!(src && baseValue)) {
        return null
    }

    return <img {...responsiveAttrs({src, baseValue, baseType, srcSizes, format, skipStripTags})} {...rest} />
}
